// extracted by mini-css-extract-plugin
var _1 = "ra-article-body";
var _2 = "ra-article";
var _3 = "ra-article-footer";
var _4 = "ra-article-header";
var _5 = "ra-article-header-details";
export { _1 as "articleBodyCls", _2 as "articleCls", _3 as "articleFooterCls", _4 as "articleHeaderCls", _5 as "articleHeaderDetailCls" }
